<template>
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        fixed
        top
        :left="position == 'left'"
        :right="position == 'right'"
        color="secondary"
        fab
        v-bind="attrs"
        v-on="on"
        @click="$emit('close')"
      >
        <v-icon>{{ icons.mdiWindowClose }}</v-icon>
      </v-btn>
    </template>
    <span>Fechar</span>
  </v-tooltip>
</template>
<script>
import { icons } from '@/plugins/helper'

export default {
  mixins: [icons],
  props: {
    position: {
      type: String,
      default: 'left',
    },
  },
}
</script>
